module.exports = __webpack_public_path__ + "static/media/PlayAlongNow-Logo_Invert.a20c7fb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PlayAlongNow-Logo_Invert.svg
// module id = ./src/assets/images/PlayAlongNow-Logo_Invert.svg
// module chunks = 0